import { render } from "./ElectionMap21.vue?vue&type=template&id=0c5278a1&scoped=true"
import script from "./ElectionMap21.vue?vue&type=script&lang=js"
export * from "./ElectionMap21.vue?vue&type=script&lang=js"

import "./ElectionMap21.vue?vue&type=style&index=0&id=0c5278a1&scoped=true&lang=css"

import exportComponent from "/Users/noursafadi/Documents/Uni/Parsons-Spring-25/MajorStudio02/MSDV-thesis-2025/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0c5278a1"]])

export default __exports__